import {
  AnimatedCheckMark,
  Button,
  Div,
  Flex,
  Text,
} from '@sendoutcards/quantum-design-ui'
import React from 'react'
import styles from './pointsPackage.module.scss'
import { useAccount } from 'src/hooks'
import { getPercentageSavings, getPricePerPoint } from 'src/helpers'
interface PointsPackageProps {
  points: number
  onSelect: (option: number, pricePerPoint: number, amount: number) => void
  isSelected: boolean
  option: number
}

const PointsPackage: React.FC<PointsPackageProps> = props => {
  const { points, onSelect, isSelected, option } = props
  const { pointPrice } = useAccount()

  const pricePerPoint = getPricePerPoint(pointPrice, points)

  return (
    <Div className={styles.pointsPackage}>
      <Flex
        flexDirection="column"
        alignItems="center"
        className={styles.pointsAmount}
      >
        <Text type="title">{points}</Text>
        <Text type="body">POINTS</Text>
      </Flex>
      <Div className={styles.pricePerPoint}>
        <Text type="footnote">${pricePerPoint} / point</Text>
      </Div>
      <Div className={styles.priceTotal}>
        <Text type="subtitle">${(pricePerPoint * points).toFixed(2)}</Text>
      </Div>
      <Div className={styles.selectPackage}>
        {isSelected ? (
          <Div cursor="pointer" onClick={() => onSelect(0, 0, 0)}>
            <AnimatedCheckMark filled={true} size="medium" />
          </Div>
        ) : (
          <Button
            size="small"
            onClick={() => onSelect(option, pricePerPoint, points)}
          >
            Select
          </Button>
        )}
      </Div>
      {pointPrice === 66 && (
        <Div className={styles.percentageSavings}>
          <Text type="caption" alignment="center">
            {getPercentageSavings(pricePerPoint)}
          </Text>
        </Div>
      )}
    </Div>
  )
}

export default PointsPackage
